import React from 'react';

import { getStepConfig } from '../../getStepConfig';
import { usePatientIntakeStatusContext } from '../../hooks';
import { ActionPrompt } from '../../components';
import type { BaseStepsBaseProps } from './BaseSteps.types.ts';

interface AccountVerificationActionProps extends BaseStepsBaseProps {}

export const AccountVerificationAction: React.FC<AccountVerificationActionProps> = ({ onEdit }) => {
  const { baseSteps, isHealthcareProvider } = usePatientIntakeStatusContext();

  const step = baseSteps?.ACCOUNT_VERIFICATION;
  const hasActiveStep = step && step.currentStatus.status !== 'NOT_STARTED';

  if (!hasActiveStep) return null;

  const stepConfig = getStepConfig('ACCOUNT_VERIFICATION');

  const title = stepConfig.title({
    step,
    isHealthcareProvider,
  });

  const description = stepConfig.statuses[step.currentStatus.status].description({
    step,
    isHealthcareProvider,
  });

  return (
    <ActionPrompt
      step={step}
      title={title}
      onClick={onEdit}
      onEdit={onEdit}
      description={description}
      isViewOnlyMode={!isHealthcareProvider}
    />
  );
};
